import styled from 'styled-components';
import { spaceMixin, token } from '@zillow/constellation';

export const StyledSectionLeft = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  list-style-type: none;

  .SectionLeft-link {
    font-size: 16px;
    padding: 0 ${spaceMixin('lg')} 0 0;

    .Link {
      color: ${token('colors.gray600')};
      text-decoration: none;
      display: inline-block;
      text-align: center;
      font-weight: 400;
    }

    .Link-messages {
      display: flex;
      flex-direction: row;
    }

    .Link:hover {
      color: ${token('colors.blue400')};
      font-weight: 600;
    }

    .Link:not(.Link-messages)::before {
      content: attr(title);
      display: block;
      font-weight: 600;
      height: 0;
      overflow: hidden;
      visibility: hidden;
    }

    .Link .messages-title::before {
      content: attr(title);
      display: block;
      font-weight: 600;
      height: 0;
      overflow: hidden;
      visibility: hidden;
    }

    .Link-active {
      color: ${token('colors.blue400')};
      font-weight: 600;
      text-decoration: none;
    }
  }
`;

export const StyledNotificationCircle = styled.div`
  position: absolute;
  width: ${spaceMixin('xs')};
  height: ${spaceMixin('xs')};
  top: -${spaceMixin('xs')};
  right: -${spaceMixin('xs')};
  border-radius: ${token('radii.ellipse')};
  background: ${token('colors.orange400')};
  color: white;
`;
